module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp-renew/img_webinar_02-049f247815c22b35c82b27fc300c2dcd.png";